import { ReactNode } from 'react';

import { Layout, scale, typography } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';
import { themeColor } from '@scripts/themes/cssVars';

export const ExpandableBlock = ({
    title,
    children,
    type,
}: {
    title?: string;
    children: ReactNode;
    type?: 'secondary';
}) => {
    const { xs } = useMedia();

    return (
        <Layout gap={0} cols={1}>
            {title && (
                <Layout.Item css={{ marginBottom: scale(3), [xs]: { marginBottom: '20px' } }}>
                    <h2 css={typography('h3')}>{title}</h2>
                </Layout.Item>
            )}

            <Layout.Item
                css={{
                    position: 'relative',
                    marginBottom: scale(2),
                    ...(type === 'secondary' && {
                        marginBottom: '0px',
                    }),
                }}
            >
                {children}
                <div
                    css={{
                        position: 'absolute',
                        background: `linear-gradient(to bottom, ${themeColor.white0}, ${themeColor.white} 100%)`,
                        bottom: 0,
                        left: 0,
                        height: scale(10),
                        width: '100%',
                        display: 'none',
                    }}
                />
            </Layout.Item>
        </Layout>
    );
};
